var map = {
	"./countries.en-US.json": [
		51103,
		103
	],
	"./countries.ja-JP.json": [
		21897,
		674
	],
	"./countries.zh-CN.json": [
		97916,
		916
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5209;
module.exports = webpackAsyncContext;